/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindTraceabilityRequestClientsQueryResponse,
  FindTraceabilityRequestClientsQueryParams,
} from "../types/FindTraceabilityRequestClients.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findTraceabilityRequestClientsQueryKey = (
  params?: FindTraceabilityRequestClientsQueryParams
) =>
  [
    { url: "/v1/traceability-requests/filters/clients" },
    ...(params ? [params] : []),
  ] as const

export type FindTraceabilityRequestClientsQueryKey = ReturnType<
  typeof findTraceabilityRequestClientsQueryKey
>

/**
 * @summary Find traceability request clients
 * {@link /v1/traceability-requests/filters/clients}
 */
export async function findTraceabilityRequestClients(
  params?: FindTraceabilityRequestClientsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTraceabilityRequestClientsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/filters/clients`,
    params,
    ...requestConfig,
  })
  return res
}

export function findTraceabilityRequestClientsQueryOptions(
  params?: FindTraceabilityRequestClientsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTraceabilityRequestClientsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindTraceabilityRequestClientsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTraceabilityRequestClientsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findTraceabilityRequestClients(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find traceability request clients
 * {@link /v1/traceability-requests/filters/clients}
 */
export function useFindTraceabilityRequestClients<
  TData = ResponseConfig<FindTraceabilityRequestClientsQueryResponse>,
  TQueryData = ResponseConfig<FindTraceabilityRequestClientsQueryResponse>,
  TQueryKey extends QueryKey = FindTraceabilityRequestClientsQueryKey,
>(
  params?: FindTraceabilityRequestClientsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTraceabilityRequestClientsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findTraceabilityRequestClientsQueryKey(params)

  const query = useQuery(
    {
      ...findTraceabilityRequestClientsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
